import { render, staticRenderFns } from "./detail-component-form.vue?vue&type=template&id=83ae3650&scoped=true"
import script from "./detail-component-form.vue?vue&type=script&lang=ts"
export * from "./detail-component-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ae3650",
  null
  
)

export default component.exports